import { UserDetails } from '../types';

export const COURTESY_ANALYSIS_LIMIT = 2;

const hasText = (value: unknown): value is string => (
  typeof value === 'string' && value.trim().length > 0
);

export const isUserDetailsComplete = (details: UserDetails | null | undefined): details is UserDetails => {
  if (!details) return false;

  return (
    hasText(details.firstName) &&
    hasText(details.lastName) &&
    hasText(details.organization) &&
    hasText(details.city) &&
    hasText(details.whatsapp) &&
    Array.isArray(details.practiceAreas) &&
    details.practiceAreas.length > 0
  );
};

export const shouldRequireUserDetails = (
  historyCount: number,
  details: UserDetails | null | undefined,
): boolean => historyCount >= COURTESY_ANALYSIS_LIMIT && !isUserDetailsComplete(details);
